import type { AgentToolDescriptor } from "./agentTypes";

export type ToolSchema = {
  name: string;
  description: string;
  parameters: { type: "object"; properties: Record<string, unknown>; required?: string[] };
};

export const catalogToToolSchemas = (tools: AgentToolDescriptor[]): ToolSchema[] =>
  tools.map((tool) => {
    const properties: Record<string, unknown> = {};
    const required = tool.params.filter((p) => p.required).map((p) => p.name);
    for (const param of tool.params) {
      properties[param.name] = { ...param.schema, ...(param.description ? { description: param.description } : {}) };
    }
    return {
      name: tool.toolName,
      description: [tool.description, tool.appliesToKind && `Gjelder kun ${tool.appliesToKind}-anskaffelser.`]
        .filter(Boolean)
        .join(" "),
      parameters: { type: "object", properties, ...(required.length ? { required } : {}) },
    };
  });
